import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

export interface IHospitalInfo {
  CultureCode: string;
  TenantId: string;
  NetworkId: string;
  HospitalId: string;
}

type State = {
  hospitalInfo: IHospitalInfo | null;
  countryCode?: string
};

type Actions = {
  addCountryCode: (countryCode: string) => void;
  addHospitalInfo: (hospitalInfo: IHospitalInfo) => void;
  clearHospitalInfo: () => void;
};

export const useHospitalStore = create(
  immer<State & Actions>((set) => ({
    hospitalInfo: null,
    countryCode: undefined,
    addCountryCode: (countryCode) => set(() => ({ countryCode })),
    addHospitalInfo: (hospitalInfo) => set(() => ({ hospitalInfo })),
    clearHospitalInfo: () => set({ hospitalInfo: null }),
  })),
);
